//(function () {
//    'use strict';

//    angular.module("imApp").factory("p2ClientUpdateEditService", ['$ihttp', function ($ihttp) {
//        let service = {
//            getEdit: function (parms) {
//                return $ihttp.post({
//                    method: 146,
//                    parameters: parms || {}
//                });
//            }
//        };

//        return service;
//    }]);
//})();
